/* @flow */
import { getterFromKeyPath } from 'trustar/utils';
import { Map, List } from 'immutable';
import * as Defaults from './defaults';


export const companyWhitelistEntries = getterFromKeyPath(['companyWhitelist', 'entries']);
export const loading = getterFromKeyPath(['companyWhitelist', 'loading']);
export const modalOpen = getterFromKeyPath(['companyWhitelist', 'modalOpen']);
export const currentQuery = getterFromKeyPath(['companyWhitelist', 'currentQuery']);

export const defaultPayload =
  Map({
    query: '',
    sort: Map(Defaults.sorterValues.searchSorters),
    pageNumber: 0,
    pageSize: 25,
  });

export const defaultResult = Map({
  empty: true,
  items: List(), // PAGE SIZE and stuff? TODO
});



// WEBPACK FOOTER //
// ./src/app/modules/company-whitelist/getters.js